// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3890d82d","239":"943cd3e2","453":"ea7b86a9","732":"2d80c6ca"}[chunkId] + ".chunk.js";
};